// extracted by mini-css-extract-plugin
export default {"paginationContainer":"stylesCustomPagination_paginationContainer__pFeeL","paginationInfo":"stylesCustomPagination_paginationInfo__Is9t-"};